import { useDispatch, useSelector } from "react-redux";
import {
  IonAvatar,
  IonCard,
  IonGrid,
  IonIcon,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonItem,
  IonLabel,
  IonLoading,
  IonNote,
  IonSearchbar,
  IonText,
  isPlatform,
  useIonViewWillEnter,
  useIonViewWillLeave,
} from "@ionic/react";
import {
  documentTextOutline,
  personOutline,
  calendarOutline,
  bookmarkOutline,
} from "ionicons/icons";
import { DocumentStatusTag } from "../../../components/Document/DocumentStatusTag";
import { selectDocuments } from "../../../store/locationShow/selectors/selectDocuments";
import { selectDocumentsFetchStatus } from "../../../store/locationShow/selectors/selectDocumentsFetchStatus";
import { setDocumentSearchText, setMaxListIndex } from "../../../store/locationShow";
import { selectDocumentsSearchText } from "../../../store/locationShow/selectors/selectDocumentsSearchText";
import { RootState } from "../../../store/rootReducer";
import { useEffect, useState } from "react";

const MIN_ITEM_ON_LIST = 10;

export const TodoListSection: React.FC = () => {
  const dispatch = useDispatch();
  const documents = useSelector(selectDocuments);
  const searchText = useSelector(selectDocumentsSearchText);
  const fetchStatus = useSelector(selectDocumentsFetchStatus);

  const maxDataList = useSelector((state: RootState) => state.locationShow.maxListIndex);

  const [infiniteDisabled, setInfiniteDisabled] = useState<boolean>(false);

  useEffect(() => {
    dispatch(setMaxListIndex(MIN_ITEM_ON_LIST));
    setInfiniteDisabled(false);
  }, [documents]);

  const pushData = () => {
    dispatch(setMaxListIndex(maxDataList + MIN_ITEM_ON_LIST));
  };

  const loadData = (ev: any) => {
    setTimeout(() => {
      pushData();
      ev.target.complete();
      if (maxDataList > documents.length) {
        setInfiniteDisabled(true);
      }
    }, 500);
  };

  useIonViewWillEnter(() => {
    dispatch(setMaxListIndex(MIN_ITEM_ON_LIST));
  });

  useIonViewWillLeave(() => {
    dispatch(setMaxListIndex(MIN_ITEM_ON_LIST));
  });

  return (
    <>
      <h2 className="ion-padding-horizontal">
        <IonText color="primary">Documentos</IonText>
      </h2>
      <h3 className="ion-padding-horizontal">
        <IonText color="primary">Acuerdos ({documents.length})</IonText>
      </h3>
      <IonSearchbar
        style={{ maxWidth: 360 }}
        placeholder="Buscar acuerdo"
        value={searchText}
        onIonChange={({ detail: { value = "" } }) => dispatch(setDocumentSearchText(value))}
        class="ion-no-padding ion-padding-start ion-padding-bottom"
      ></IonSearchbar>
      {/* {fetchStatus === "pending" && <p>Cargando...</p>} */}
      <IonLoading isOpen={fetchStatus === "pending"} message={"Cargando..."} />
      {fetchStatus === "fulfilled" && (
        <IonGrid>
          {documents.length === 0 && (
            <IonCard>
              <IonItem lines="none">
                <IonLabel>
                  <IonText color="medium">No se han encontrado acuerdos</IonText>
                </IonLabel>
              </IonItem>
            </IonCard>
          )}
          {documents.slice(0, maxDataList).map((document) => (
            <IonCard key={document.id} class="ion-margin-bottom">
              <IonItem routerLink={`/app/supervision/acuerdos/${document.id}`} lines="none">
                {isPlatform("desktop") && (
                  <IonAvatar slot="start">
                    <IonIcon icon={documentTextOutline} size="large" />
                  </IonAvatar>
                )}
                <IonLabel>
                  <h2 style={{ fontWeight: 500 }} className="ion-text-wrap">
                    {document.title}
                  </h2>
                  <h4>
                    <IonIcon icon={personOutline}></IonIcon>
                    <IonText class="ion-padding-start">{document.author?.name}</IonText>
                  </h4>
                  <p>
                    <IonIcon icon={calendarOutline}></IonIcon>
                    <IonText class="ion-padding-start">{document.createdAt}</IonText>

                    <IonIcon icon={bookmarkOutline} class="ion-padding-start" />
                    <IonText class="ion-padding-start">{`${document.category?.name}`}</IonText>
                  </p>
                </IonLabel>

                <IonNote slot="end">
                  <DocumentStatusTag document={document} />
                </IonNote>
              </IonItem>
            </IonCard>
          ))}
          <IonInfiniteScroll onIonInfinite={loadData} threshold="10px" disabled={infiniteDisabled}>
            <IonInfiniteScrollContent loadingSpinner="bubbles" loadingText="Cargar más datos..." />
          </IonInfiniteScroll>
        </IonGrid>
      )}
    </>
  );
};
